import { render, staticRenderFns } from "./StepModal.vue?vue&type=template&id=61e72c9a&"
import script from "./StepModal.vue?vue&type=script&lang=js&"
export * from "./StepModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e72c9a')) {
      api.createRecord('61e72c9a', component.options)
    } else {
      api.reload('61e72c9a', component.options)
    }
    module.hot.accept("./StepModal.vue?vue&type=template&id=61e72c9a&", function () {
      api.rerender('61e72c9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/StepModal.vue"
export default component.exports